var Midttrafik2016 = Midttrafik2016 || {};

Midttrafik2016.extranetQuestions = new function () {
    var self = this;
    this.init = function() {
        this.switch();
    };

    this.switch = function () {
        if ($('.timetable-suggetion').length > 0)
            return;

        $('.extranet-tabs__tab').click(function() {
            $('.extranet-tabs__tab').removeClass('extranet-tabs__tab--active');
            $(this).addClass('extranet-tabs__tab--active');
        });

        $('.js-ask-question').click(function() {
            $('.extranet-questions-list').hide();
            $('.ask-question').show();
        });
        $('.js-show-questions').click(function() {
            $('.extranet-questions-list').show();
            $('.ask-question').hide();
        });
    };
}();
